import React from "react";
import { GraduationCap, Home, Languages, LayoutDashboard, LogOut, MailCheck } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useLanguage } from "../../i18n/LanguageContext";
import { siteUrl } from "../../config/urls";

const UserSidebar = ({ open = false, onClose }) => {
  const navigate = useNavigate();
  const { isEnglish, toggleLanguage } = useLanguage();
  const links = [{ to: "/user/dashboard", label: isEnglish ? "Professor outreach" : "مکاتبه با استادها", icon: LayoutDashboard }, { to: "/user/profile", label: isEnglish ? "Academic profile" : "پروفایل آکادمیک", icon: GraduationCap }, { to: "/user/userEmailes", label: isEnglish ? "Email reports" : "گزارش ایمیل‌ها", icon: MailCheck }];
  const signOut = () => {
    const cookies = new Cookies();
    cookies.remove("role", { path: "/" }); cookies.remove("token", { path: "/" }); cookies.remove("name", { path: "/" });
    navigate("/SignIn", { replace: true });
  };
  return <aside className={`workspace-sidebar ${open ? "is-open" : ""}`}>
    <a className="workspace-brand" href={siteUrl("/")} onClick={onClose}><span className="workspace-infinity" aria-hidden="true">∞</span><div><strong>Infinity Apply</strong><span>{isEnglish ? "Academic outreach workspace" : "پنل مکاتبهٔ تحصیلی"}</span></div></a>
    <nav>{links.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} onClick={onClose} className={({ isActive }) => isActive ? "is-active" : ""}><Icon size={18} /><span>{label}</span></NavLink>)}</nav>
    <div className="workspace-sidebar-foot"><button onClick={toggleLanguage}><Languages size={18} />{isEnglish ? "فارسی" : "English"}</button><a href={siteUrl("/")} onClick={onClose}><Home size={18} />{isEnglish ? "Back to website" : "بازگشت به سایت"}</a><button onClick={signOut}><LogOut size={18} />{isEnglish ? "Sign out" : "خروج از حساب"}</button></div>
  </aside>;
};

export default UserSidebar;
